import { NgModule } from '@angular/core';

import { SharedModule } from "../shared/shared.module";
import { PessoasModule } from "./pessoas/pessoas.module";
import { RecursosHumanosComponent } from './recursos-humanos.component';
import { MotoristasModule } from "./motoristas/motoristas.module";
import { FuncionariosModule } from "./funcionarios/funcionarios.module";
import { RecursosHumanosRoutingModule } from "./recursos-humanos-routing.module";
import { ContatosModule } from "./contatos/contatos.module";
import { PessoaJuridicaModule } from "./pessoa-juridica/pessoa-juridica.module";
import { UsuariosModule } from "./usuarios/usuarios.module";

@NgModule({
    imports: [
        SharedModule,
        PessoasModule,
        MotoristasModule,
        FuncionariosModule,
        ContatosModule,
        PessoaJuridicaModule,
        UsuariosModule,
        RecursosHumanosRoutingModule
    ],
    declarations: [
        RecursosHumanosComponent
    ]
})
export class RecursosHumanosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/recursos-humanos.module.ts
 **/